module.exports = "<template> <sio-uploaded-file-input config.bind=field value.bind=field.value></sio-uploaded-file-input> </template>";